// extracted by mini-css-extract-plugin
module.exports = {"updatePasswordContainer":"updatePassword_updatePasswordContainer__3jrkT","error":"updatePassword_error__lmkm2"};